import React, { Component } from 'react'
import { compose } from 'recompose'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { getHotSettings } from './gridSettings';
import _ from 'lodash'
import { HotTable } from '@handsontable/react';
import Handsontable from 'handsontable';
import styles from './styles.scss';
import CSSModules from 'helpers/CSSModulesUtil'


class Grid extends Component {
  static propTypes = {    
    list: PropTypes.array.isRequired,            // data source for grid     

    setColumnReorder: PropTypes.bool.isRequired, // enable or disable column reordering
    onColumnReorder: PropTypes.func,             // callback on reordering columns

    cellClick: PropTypes.bool.isRequired,
    dynamicData: PropTypes.bool,        // enable or disable cell click to redirect to a different page
    getCellClickURL: PropTypes.func,
    actionOnCellClick: PropTypes.func,             // URL of the page to redirect to on cell click 

    loadOnScroll: PropTypes.bool.isRequired,     // enable or disable fetching of portions of data from the API while scrolling
    onSectionRendered: PropTypes.func,           // callback required to fetch the next portion of data
    changedProjects: PropTypes.array,
    showContextMenu: PropTypes.bool.isRequired,  // enable or disable menu popup on right clicking a column header
    onHeaderClick: PropTypes.func,               // callback on opening a column menu popup
    onApplyFilter: PropTypes.func,               // callback on saving filters from a menu popup
    sortBy: PropTypes.string,                    
    sortIndex: PropTypes.number                  
  }

  constructor(props) {
    super(props);
    this.state = {
      redirectRequest: false,
      redirectLink: '',
      reorderInProgress: false,
      list: props.list,
      sortIndex: props.showContextMenu ? this.props.sortIndex : '',
      selectedProjects: props.selectedProjects ? props.selectedProjects : [],
      changedProjects: this.props.changedProjects || []
    };

    const settingsConfig =  {
      list: this.state.list,
      cellClick: props.cellClick, 
      contextMenuRenderer: this.contextMenuRenderer,
      colHeaderRenderer: this.colHeaderRenderer,
      selectedRow: this.selectedRow,
      modifiedRow: this.modifiedRow,
      normalRow: this.normalRow,
      rowRenderer: this.rowRenderer,
      setColumnReorder: props.setColumnReorder,
      multiSelect: props.multiSelect,
      selectedProjects: props.selectedProjects || [],
      changedProjects: props.changedProjects || [],
      selectedRows: this.selectedRows || [],
    };
    this.hotSettings = getHotSettings(settingsConfig);
    this.selectedProjects = [];
    // reference to handsontable component
    this.hotTableComponent = React.createRef();
    // reference to handsontable instance
    this.hotInstance;
    // handsontable plugins
    this.autoRowSizer;
    this.autoColumnSizer;

    // index of current top row in viewport
    this.topRowIndex = 0; 
    // index of current bottom row of viewport
    this.bottomRowIndex = 0;
    // index of current bottom row of viewport
    this.firstVisibleColIndex = 0;
  }

  componentDidMount() {
    const { loadOnScroll, setColumnReorder, cellClick } = this.props;

    // The Handsontable instance is stored under the `hotInstance` property of the wrapper component.
    this.hotInstance = this.hotTableComponent.current.hotInstance;

    // add callbacks and load required plugins
    if (loadOnScroll) {
      this.autoRowSizer = this.hotInstance.getPlugin('AutoRowSize');
      this.autoColumnSizer = this.hotInstance.getPlugin('AutoColumnSize');
      this.hotInstance.addHook('afterScrollVertically', this.onScrollVertical);
      this.hotInstance.addHook('afterScrollHorizontally', this.onScrollHorizontal);
      this.hotInstance.addHook('afterUpdateSettings', this.onSettingsUpdate);
    }

    if (setColumnReorder) 
      this.hotInstance.addHook('afterColumnMove', this.onColumnReorder);
    if (cellClick) {
      this.hotInstance.addHook('afterOnCellMouseDown', this.onCellClick);       // left click
      this.hotInstance.addHook('beforeOnCellContextMenu', this.onContextMenu);  // right click
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // reorderInProgress flag is used to prevent re-rendering when props are updated due to reordering
    // this is needed because handsontable automatically takes care of re-rendering after column reordering
    if (this.state.reorderInProgress) 
      return false;

    return (
      !_.isEqual(this.props.list, nextProps.list)                   
      || (this.state.redirectRequest != nextState.redirectRequest)
    );
  }

  componentDidUpdate(prevProps, nextState) {
    if (!_.isEqual(this.props.list, prevProps.list)) {
      this.setState({
        list: this.props.list,
        sortIndex: this.props.showContextMenu ? this.props.sortIndex : ''
      }, () => {
        this.hotInstance.updateSettings({
          colHeaders: (index) => {
            return (
              this.props.showContextMenu 
              ? this.colHeaderRenderer(index) 
              : (this.state.list && this.state.list.length) ? this.state.list[0][index] : '')
          },
          data: (this.state.list && this.state.list.length) ? this.state.list.slice(1) : []
        })
      })
    }

    if(prevProps.selectedProjects) {
      if(this.props.selectedProjects.length < 1 && prevProps.selectedProjects.length < 1) {
        this.setState({
          selectedProjects: []
        })
      }
  
      if(this.props.selectedProjects.length < 1 && prevProps.selectedProjects.length > 0) {
        this.setState({
          selectedProjects: []
        })
      }
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // console.log(this.props.selectedProjects.length > 0 && nextProps.selectedProjects.length === 0)
    if (this.props.selectedProjects) {
      if (this.props.selectedProjects.length > 0 && nextProps.selectedProjects.length === 0) {
        this.setState({
          selectedProjects: []
        }, () => this.hotInstance.render())
      }
    }

  }

  onScrollVertical = () => {
    this.topRowIndex = this.autoRowSizer.getFirstVisibleRow();
    this.bottomRowIndex = this.autoRowSizer.getLastVisibleRow();
    if (this.state.list.length - 1 - this.bottomRowIndex < 10) {
      this.props.onSectionRendered(this.topRowIndex, this.bottomRowIndex);
    }
  } 

  onScrollHorizontal = () => {
    this.firstVisibleColIndex = this.autoColumnSizer.getFirstVisibleColumn();
  }

  onContextMenu = (e, coords) => {
    const rightClickID = 2;
    if (e.button == rightClickID) {
      if (coords.row < 0) {
        e.stopImmediatePropagation();
        e.preventDefault();
        if (this.props.showContextMenu) this.props.onHeaderClick(e.clientX - e.offsetX - (window.innerWidth * .17), coords.col);
      } else {
        const id = this.state.list[coords.row+1][0];
        this.setState({redirectLink: this.props.getCellClickURL(id)})
      }
    }
  }

  onCellClick = (e, coords, TD) => {
    const leftClickID = 0;
    if (e.target.baseURI.includes("myprojects")){
      if (coords.col > 0) {
        const { list } = this.state;
        const id = list[coords.row + 1][0]
        if (typeof id === 'string'){
        } else {
          this.props.actionOnCellClick(id)
          let current = this.state.selectedProjects
          if (current.indexOf(id) > -1) {
            current.splice(current.indexOf(id), 1)
          } else {
            current.push(id)
          }
          this.setState({
            selectedProjects: current
          }, () => {
            return this.hotInstance.render()
          })
        }
      } else {
        const getRedirectURL = (rowIndex) => {
          const { list } = this.state;
          const id = list[rowIndex+1][0];
          return this.props.getCellClickURL(id);
        }
        const redirectLink = getRedirectURL(coords.row);
        window.open(redirectLink)
        // this.setState({
        //   redirectRequest: true,
        //   redirectLink: redirectLink
        // });
      }


    } else if (e.button == leftClickID && coords.row >= 0) {
      const getRedirectURL = (rowIndex) => {
        const { list } = this.state;
        const id = list[rowIndex+1][0];
        return this.props.getCellClickURL(id);
      }
      const redirectLink = getRedirectURL(coords.row);
      this.setState({
        redirectRequest: true,
        redirectLink: redirectLink
      });
    }
  }

  onSettingsUpdate = () => {
    // scroll to previous viewport when table is re-rendered
    this.hotInstance.scrollViewportTo(this.topRowIndex, this.firstVisibleColIndex);
  }

  onColumnReorder = (colsMoved, targetIndex) => {
    this.setState({reorderInProgress: true});
    this.props.onColumnReorder(colsMoved, targetIndex)
    this.setState({reorderInProgress: false});
  }

  colHeaderRenderer = (index) => {
    const descSymbol = '&#9660;';
    const ascSymbol = '&#9650;';
    let headerContent = (this.state.list && this.state.list.length) ? this.state.list[0][index] : '';

    if (this.state.sortIndex == index) {
      if (this.props.sortBy == "desc") {
        headerContent = `<p>${headerContent} <span class=${styles.sortSymbol}>${descSymbol}</span> </p>`;
      } else {
        headerContent = `<p>${headerContent} <span class=${styles.sortSymbol}>${ascSymbol}</span></p>`;
      }
    }

    return headerContent;
  }

  contextMenuRenderer = () => {
    return {
      items: {
        'open_in_same_tab': {
          name: 'View Details',
          callback: () => {
            this.setState({redirectRequest:true}); // use react-router redirect
          }
        },
        'separator': Handsontable.plugins.ContextMenu.SEPARATOR,
        'open_in_new_tab': {
          name: 'Open details in new tab',
          callback: () => {
            const redirectURL = `${window.location.origin}${this.state.redirectLink}`;
            window.open(redirectURL);
          }
        }
      }
    }
  }
  
  rowRenderer = (instance, td, row, col, prop, value, cellProperties) => {
    Handsontable.renderers.TextRenderer.apply(this, [instance, td, row, col, prop,value,cellProperties])
    
    if (instance && instance.getSourceDataAtRow(row)) {
      let currentRow = instance.getSourceDataAtRow(row)[0]
      let current = "htMiddle handsontableCustomTheme htDimmed"
  
      if (this.props.changedProjects) {
        let changed = this.props.changedProjects.map((project) => {
          return project.id
        })
        
        if (changed.includes(currentRow)) {
          td.className = current + " changedRow"
        }
      }
  
      if (this.state.selectedProjects.includes(currentRow)) {
        td.className = current + " selectedRow"
      }

    }

  }

  render() {
    const { redirectRequest, redirectLink } = this.state;
    return (
      <React.Fragment>
        {redirectRequest ? <Redirect push to={redirectLink}></Redirect>
        : 
        <HotTable
          theme={styles}
          ref={this.hotTableComponent}
          id="hot"
          settings={this.hotSettings}
        />
        }
      </React.Fragment>
    );
  }
}

const withStyle = CSSModules(styles)
const enhance = compose(
  withStyle
)
export default enhance(Grid);